import { WarningIcon } from "./warning_icon";

export function AvAlert({ message }: { message: string }) {
  return (
    <div className="alert-wrapper flex justify-center px2 py1">
      <span className="mr1">
        <WarningIcon color="white" />
      </span>
      <span className="body-xs bold mr1">{message}</span>
    </div>
  );
}
